import React, { useContext } from "react";
import { Navigate } from "react-router";
import { AuthContext } from "./authcontext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { token, isLoading } = useContext(AuthContext);

  if (isLoading) {
    // Return null or a loading spinner while checking auth
    return null;
  }

  if (!token) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
